<div class="fst-italic ellipsis">
     <i class="fa-regular pe-2" [ngClass]="review.icon"></i>
     @if(review.reviewType !== 'NewThreadReview'){<span class="name-color">{{reviewer}}</span> }{{review.text(userId, translateService) | translate}}
     <span class="px-1">•</span>
     <i [matTooltip]="review.date | date: 'medium'" matTooltipPosition="above">{{review.date | time_from_now }}</i>
</div>